import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider } from 'primereact/api';
import ScrollToTop from './ScrollToTop.jsx';
import { AppContextProvider } from './context/AppContext.jsx';
import { HashRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <HashRouter>
        <AppContextProvider>
          <ScrollToTop />
          <App />
        </AppContextProvider>
      </HashRouter>
    </PrimeReactProvider>
  </React.StrictMode>
);


reportWebVitals();
